(ns minorodata.components.file-ingest.preview-data
  (:require [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [minorodata.components.spinner.core :as c.spinner]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.button :refer [button]]
            [ui.card :refer [card]]
            [ui.stepper :as stepper]
            [ui.table :refer [table tbody td tr]]
            [ui.tabs :refer [tabs]]
            [ui.typography :as typography]))


(defn handle-response [header-row]
  (dispatch [:ingest-header-row/delete])
  (dispatch [:file-ingest.events/set-header-row header-row]))


(defn preview-table [{:keys [rows]}]
  [:div {:class "overflow-x-auto"}
   [table
    [tbody
     (for [[x-idx cols] (map-indexed vector rows)
           :let [first-row? (zero? x-idx)]]
       ^{:key x-idx}
       [tr
        (for [[y-idx col] (map-indexed vector cols)]
          ^{:key (str x-idx "-" y-idx)}
          [td {:class (when first-row? "border border-kleene-text-success")}
           col])])]]])

(defn header-selection []
  (let [selected-response (reagent/atom "yes")]
    (fn []
      [stepper/stepper-footer {:class "justify-between border-t-0"}
       [:div {:class "flex items-center gap-4"}
        [typography/p {}
         "Does the highlighted row contain column names?"]

        [tabs {:tabs            [{:value "yes"
                                  :label "Yes"
                                  :data-cy :header-row__yes}
                                 {:value "no"
                                  :label "No"
                                  :data-cy :header-row__no}]
               :value           @selected-response
               :on-value-change #(reset! selected-response %)}]]

       [button {:data-cy  :header-row__proceed
                :on-click (fn header-selection-proceed []
                            (case @selected-response
                              "yes" (handle-response 0)
                              "no"  (handle-response nil)
                              (js/console.warn "Invalid option")))}
        "Proceed"]])))

(defn preview-data-render [{:keys [rows loading?]}]
  [:<>
   [card {:class "p-4"}
    (if loading?
      [:div {:class "flex min-h-[200px] items-center justify-center text-kleene-text-secondary"}
       [c.spinner/with-text {:text "Loading..."}]]
      [preview-table {:rows rows}])]

   [header-selection]])


(defn reset-upload-preview-error []
  (dispatch [:ingest-preview-data/delete])
  (dispatch [:file-ingest.events/set-wizard-step :upload-file]))

(defn preview-data-error-render [{:keys [error-message]}]
  [:div {:class "flex flex-col items-center max-w-xl w-full mx-auto"}
   [:div {:class "my-6"}
    [typography/p {:class "text-center"}
     "An error occurred trying to process the file"]]

   [card {:class "p-4 w-full"}
    [:pre {:class "text-kleene-error-01"}
     (str error-message)]]

   [:div {:class "mt-4"}
    [button {:data-cy  :ingest-reset-upload
             :on-click reset-upload-preview-error}
     "Try a different file"]]])


(defn preview-data []
  (let [rows          (re-posh/subscribe [:file-ingest.subs/preview-data])
        loading?      (re-posh/subscribe [:mold-http/loading? :file-ingest.api/load-preview])
        error?        (re-posh/subscribe [:ingest-preview-data/prop :ingest-preview-data/preview-error?])
        error-message (re-posh/subscribe [:ingest-preview-data/prop :ingest-preview-data/preview-error-message])]
    (reagent/create-class
     {:display-name
      "preview-data"

      :constructor
      (fn []
        (dispatch-sync [:file-ingest.api/preview-data]))

      :render
      (fn []
        (if @error?
          [preview-data-error-render
           {:error-message @error-message}]
          [preview-data-render
           {:rows          @rows
            :loading?      @loading?}]))})))
